import { SkeletonBase } from './styles';

interface GraphSkeletonProps {
  height?: string
}

const GraphSkeleton = ({ height = '100%' }: GraphSkeletonProps) => (
  <SkeletonBase height={height}/>
);

export default GraphSkeleton;